import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { SessionErrorComponent } from './session-error/session-error.component'
import { HelpComponent } from './help/help.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { SbeComponent } from './sbe/sbe.component';
import { DoneComponent } from './done/done.component';
import { NysbeComponent } from './nysbe/nysbe.component';

const routes: Routes = [
  { path: '', component:  MainComponent },
  { path: 'sessionError', component: SessionErrorComponent },
  { path: 'help', component: HelpComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'terms', component: TermsAndConditionsComponent },
  { path: 'sbe', component: SbeComponent },
  { path: 'ffm', component: SbeComponent },
  { path: 'SP', component: SbeComponent },
  { path: 'HealthSherpa', component: SbeComponent },
  { path: 'HS', component: SbeComponent },
  { path: 'done', component: DoneComponent },
  { path: 'neny', component: NysbeComponent },
  { path: 'wny', component: NysbeComponent },
  { path: 'w3ll', component: SbeComponent  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
